/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */
import { Formdatadetail } from './formdatadetail.model';


export class SectionTabBlock {
    tabCode: string; // ecf001
    sectionCode: string; // ecf001
    blockCode: string; // ecf001
    values?: Formdatadetail[]; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): SectionTabBlock {
        if (!data) { return instance; }
        if (data.tabCode != null) {instance.tabCode = data.tabCode; }
        if (data.sectionCode != null) {instance.sectionCode = data.sectionCode; }
        if (data.blockCode != null) {instance.blockCode = data.blockCode; }
        if (data.values != null) {
            instance.values = [];
            ([].concat(data.values)).forEach(occurrence => {
                instance.values.push(new Formdatadetail().fromJSON(occurrence)); // i3
            });
        }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return SectionTabBlock.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: SectionTabBlock) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return SectionTabBlock.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: SectionTabBlock): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
